import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import { toTitleCase } from "../../../Utils/stringUtls";
import {
  cardActivationMethod,
  cardChannelIndividual,
  cardPlacement,
  cardholderNotify,
  cardsActivationChannel,
  consumerFundingSource,
  corporateFundingSource,
  customerSupportChannel,
  kycResponsibility,
  notificationChannels,
} from "../ProgramFeatures";

const ProgramFeatures = ({ data }) => {
  if (!data) return <DataNotFound />;

  const {
    pf_enable_kyc_conduct,
    pf_kyc_conduct,
    pf_kyc_conduct_other_company,
    pf_kyc_conduct_other_contact_name,
    pf_kyc_conduct_other_title,
    pf_kyc_conduct_other_phone,
    pf_kyc_conduct_other_phone_country,
    pf_kyc_conduct_other_email,
    pf_kyc_conduct_other_address,
    pf_funding_source_consumer_option = [],
    pf_funding_source_corporate_option,
    pf_funding_source_corporate_other_company,
    pf_funding_source_corporate_other_contact_name,
    pf_funding_source_corporate_other_title,
    pf_funding_source_corporate_other_phone,
    pf_funding_source_corporate_other_phone_country,
    pf_funding_source_corporate_other_email,
    pf_funding_source_corporate_other_address,
    pf_card_placement,
    pf_card_placement_channel = [],
    pf_supplimentary_cards_permitted,
    pf_supplimentary_cards_age_limit,
    supplimentary_cards_own_profile,
    supplimentary_cards_share_primary_balance,
    pf_card_activation_required,
    pf_card_activation_method,
    pf_card_activation_channels = [],
    pf_card_activation_channels_other,
    pf_card_offline_pin_required,
    pf_cardholder_notifications,
    pf_cardholder_notifications_channels,
    pf_customer_support_channels = [],
    pf_customer_support_provider,
    pf_customer_support_provider_other_company,
    pf_customer_support_provider_other_contact_name,
    pf_customer_support_provider_other_title,
    pf_customer_support_provider_other_phone,
    pf_customer_support_provider_other_phone_country,
    pf_customer_support_provider_other_email,
  } = data["5_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Card Holder Authentication
          </div>
          <div className="review-summary-sub-heading">
            Would you like KYC enabled for this program?
          </div>
          <div className="review-summary-sub-heading">
            {pf_enable_kyc_conduct?.length
              ? pf_enable_kyc_conduct.toUpperCase()
              : "-"}
          </div>
        </div>
        {pf_enable_kyc_conduct === "yes" ? (
          <div i2c-grid="12@md">
            <div className="review-summary-sub-heading mb-4 font-bold">
              Who will conduct KYC?
            </div>
            <div i2c-grid="grid gap-sm">
              {pf_kyc_conduct === "other" ? (
                <>
                  <div
                    i2c-grid="12@md"
                    className="overview-help-text font-bold"
                  >
                    3rd Party vendor details
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Name</div>
                    <div className="overview-val-text">
                      {pf_kyc_conduct_other_company?.length
                        ? toTitleCase(pf_kyc_conduct_other_company)
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Contact name
                    </div>
                    <div className="overview-val-text">
                      {pf_kyc_conduct_other_contact_name?.length
                        ? toTitleCase(pf_kyc_conduct_other_contact_name)
                        : "-"}
                    </div>
                  </div>

                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Job Title
                    </div>
                    <div className="overview-val-text">
                      {pf_kyc_conduct_other_title?.length
                        ? pf_kyc_conduct_other_title
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Phone</div>
                    <div className="overview-val-text">
                      {pf_kyc_conduct_other_phone?.length
                        ? pf_kyc_conduct_other_phone
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">Email</div>
                    <div className="overview-val-text">
                      {pf_kyc_conduct_other_email?.length
                        ? toTitleCase(pf_kyc_conduct_other_email)
                        : "-"}
                    </div>
                  </div>
                  <div i2c-grid="6@md">
                    <div className="overview-help-text font-bold">
                      Physical Address
                    </div>
                    <div className="overview-val-text">
                      {pf_kyc_conduct_other_address?.length
                        ? toTitleCase(pf_kyc_conduct_other_address)
                        : "-"}
                    </div>
                  </div>
                </>
              ) : (
                <div i2c-grid="12@md" className="overview-val-text">
                  {kycResponsibility.find((res) => res.value === pf_kyc_conduct)
                    ?.label ?? "-"}
                </div>
              )}
            </div>
          </div>
        ) : null}
        <div i2c-grid="12@md">
          <div className="review-summary-sub-heading mb-4 font-bold">
            Funding Source for the Cards
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Loaded by the consumer through
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {pf_funding_source_consumer_option?.length
              ? consumerFundingSource.map((source, index) =>
                  pf_funding_source_consumer_option?.includes(source.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>{source.label},</span>
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Loaded by the corporate entity through
          </div>
          <div className="overview-val-text">
            {pf_funding_source_corporate_option?.length
              ? corporateFundingSource.find(
                  (opt) => opt.value === pf_funding_source_corporate_option,
                ).label
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div i2c-grid="grid gap-sm">
            {pf_funding_source_corporate_option === "other" ? (
              <>
                <div i2c-grid="12@md" className="overview-help-text font-bold">
                  3rd Party vendor details
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Name</div>
                  <div className="overview-val-text">
                    {pf_funding_source_corporate_other_company?.length
                      ? toTitleCase(pf_funding_source_corporate_other_company)
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">
                    Contact name
                  </div>
                  <div className="overview-val-text">
                    {pf_funding_source_corporate_other_contact_name?.length
                      ? toTitleCase(
                          pf_funding_source_corporate_other_contact_name,
                        )
                      : "-"}
                  </div>
                </div>

                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Job Title</div>
                  <div className="overview-val-text">
                    {pf_funding_source_corporate_other_title?.length
                      ? pf_funding_source_corporate_other_title
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Phone</div>
                  <div className="overview-val-text">
                    {pf_funding_source_corporate_other_phone?.length
                      ? pf_funding_source_corporate_other_phone
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">Email</div>
                  <div className="overview-val-text">
                    {pf_funding_source_corporate_other_email?.length
                      ? toTitleCase(pf_funding_source_corporate_other_email)
                      : "-"}
                  </div>
                </div>
                <div i2c-grid="6@md">
                  <div className="overview-help-text font-bold">
                    Physical Address
                  </div>
                  <div className="overview-val-text">
                    {pf_funding_source_corporate_other_address?.length
                      ? toTitleCase(pf_funding_source_corporate_other_address)
                      : "-"}
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Card Order Placement
          </div>
          <div className="overview-val-text">
            {pf_card_placement?.length
              ? cardPlacement.find((opt) => opt.value === pf_card_placement)
                  .label
              : "-"}
          </div>
        </div>

        {pf_card_placement_channel?.length && (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">
              Card Order Placement Channels
            </div>
            <div className="overview-val-text">
              {pf_card_placement_channel.map((value, index) => {
                return (
                  <span key={index}>
                    {cardChannelIndividual.find((ind) => ind.value === value)
                      ?.label + ", "}
                  </span>
                );
              })}
            </div>
          </div>
        )}

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Secondary/Supplementary Cards
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Are secondary/supplementary cards permitted?
          </div>
          <div className="overview-val-text">
            {pf_supplimentary_cards_permitted?.length
              ? pf_supplimentary_cards_permitted.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Is the seconday supplementary card 18+?
          </div>
          <div className="overview-val-text">
            {" "}
            {pf_supplimentary_cards_age_limit?.length
              ? pf_supplimentary_cards_age_limit.toUpperCase()
              : "-"}
          </div>
        </div>
        {pf_supplimentary_cards_permitted === "yes" ? (
          <>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">
                Will the secondary cards have their own profile?
              </div>
              <div className="overview-val-text">
                {supplimentary_cards_own_profile?.length
                  ? supplimentary_cards_own_profile.toUpperCase()
                  : "-"}
              </div>
            </div>
            <div i2c-grid="6@md">
              <div className="overview-help-text font-bold">
                If Yes, will they share balance with the Primary Card?
              </div>
              <div className="overview-val-text">
                {supplimentary_cards_share_primary_balance?.length
                  ? supplimentary_cards_share_primary_balance.toUpperCase()
                  : "-"}
              </div>
            </div>
          </>
        ) : null}
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Activation Required?
          </div>
          <div className="overview-val-text ">
            {pf_card_activation_required?.length
              ? pf_card_activation_required.toUpperCase()
              : "-"}
          </div>
        </div>
        {pf_card_activation_required === "yes" ? (
          <>
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Card Activation Channels
              </div>
              <div className="overview-val-text ">
                {pf_card_activation_channels.map((opt, index) => {
                  return (
                    <span key={index}>
                      {cardsActivationChannel.find((op) => op.value === opt)
                        ?.label === "Other"
                        ? pf_card_activation_channels_other + ", "
                        : cardsActivationChannel.find((op) => op.value === opt)
                            ?.label + ", "}
                    </span>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          <>
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                Card Activation Method
              </div>
              <div className="overview-val-text ">
                {pf_card_activation_method?.length
                  ? cardActivationMethod.find(
                      (opt) => opt.value === pf_card_activation_method,
                    )?.label
                  : "-"}
              </div>
            </div>
          </>
        )}
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">Offline PIN</div>
          <div className="overview-help-text">
            Confirm if offline PIN support is required
          </div>
          <div className="overview-val-text">
            {pf_card_offline_pin_required?.length
              ? pf_card_offline_pin_required.toUpperCase()
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Cardholder Notifications
          </div>
          <div className="overview-val-text">
            {pf_cardholder_notifications?.length
              ? cardholderNotify.find(
                  (opt) => opt.value === pf_cardholder_notifications,
                ).label
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Select the channel through which alerts data will be shared.
          </div>
          <div className="overview-val-text">
            {pf_cardholder_notifications_channels?.length
              ? pf_cardholder_notifications === "send-to-holders"
                ? notificationChannels.find(
                    (opt) => opt.value === pf_cardholder_notifications_channels,
                  )?.label
                : [
                    { label: "PUSH", value: "push" },
                    { label: "SMPP", value: "smpp" },
                  ].find(
                    (opt) => opt.value === pf_cardholder_notifications_channels,
                  )?.label
              : "-"}
          </div>
        </div>

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Customer Support Channel
          </div>
          <div className="overview-help-text font-bold">
            Please confirm what customer support will be available to the
            cardholders
          </div>
          <div className="overview-val-text">
            <div
              className="overview-val-text"
              style={{
                display: "flex",
                gap: "var(--i2c-spacing-3)",
                flexWrap: "wrap",
              }}
            >
              {pf_customer_support_channels?.length
                ? customerSupportChannel.map((source, index) =>
                    pf_customer_support_channels?.includes(source.value) ? (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "var(--i2c-spacing-2)",
                        }}
                        key={index}
                      >
                        <span>{source.label},</span>
                      </span>
                    ) : (
                      ""
                    ),
                  )
                : "-"}
            </div>
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Who will provide customer support?
          </div>
          <div className="overview-val-text">
            <div i2c-grid="12@md">
              <div i2c-grid="grid gap-sm">
                {pf_customer_support_provider !== "i2c" ? (
                  <>
                    <div
                      i2c-grid="12@md"
                      className="fw-500 review-summary-sub-heading"
                    >
                      Client/Third Party
                    </div>
                    <div i2c-grid="6@md">
                      <div className="overview-help-text font-bold">Name</div>
                      <div className="overview-val-text">
                        {pf_customer_support_provider_other_company?.length
                          ? toTitleCase(
                              pf_customer_support_provider_other_company,
                            )
                          : "-"}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="overview-help-text font-bold">
                        Contact name
                      </div>
                      <div className="overview-val-text">
                        {pf_customer_support_provider_other_contact_name?.length
                          ? toTitleCase(
                              pf_customer_support_provider_other_contact_name,
                            )
                          : "-"}
                      </div>
                    </div>

                    <div i2c-grid="6@md">
                      <div className="overview-help-text font-bold">
                        Job Title
                      </div>
                      <div className="overview-val-text">
                        {pf_customer_support_provider_other_title?.length
                          ? pf_customer_support_provider_other_title
                          : "-"}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="overview-help-text font-bold">Phone</div>
                      <div className="overview-val-text">
                        {pf_customer_support_provider_other_phone?.length
                          ? pf_customer_support_provider_other_phone
                          : "-"}
                      </div>
                    </div>
                    <div i2c-grid="6@md">
                      <div className="overview-help-text font-bold">Email</div>
                      <div className="overview-val-text">
                        {pf_customer_support_provider_other_email?.length
                          ? toTitleCase(
                              pf_customer_support_provider_other_email,
                            )
                          : "-"}
                      </div>
                    </div>
                  </>
                ) : (
                  <span>i2c Inc</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProgramFeatures;
